import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const ProductImageSlider = ({ images = [], productTitle, isListView = false }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-slide every 3 seconds
  useEffect(() => {
    if (images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const goToNext = (e) => {
    e.stopPropagation();
    if (images.length <= 1) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goToPrevious = (e) => {
    e.stopPropagation();
    if (images.length <= 1) return;
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index, e) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  if (!images || images.length === 0) {
    return (
      <img
        src={process.env.REACT_APP_S3_URL + "/uploads/shop/gallery-images/placeholder.jpg"}
        alt={productTitle}
        style={isListView ? styles.productListImage : styles.productImage}
      />
    );
  }

  return (
    <div style={styles.sliderContainer}>
      <div style={styles.imageWrapper}>
        <img
          src={process.env.REACT_APP_S3_URL + "/uploads/shop/gallery-images/" + images[currentImageIndex]}
          alt={`${productTitle} - Image ${currentImageIndex + 1}`}
          style={{
            ...(!isListView ? styles.productImage : styles.productListImage),
            transition: 'opacity 0.6s ease-in-out',
            opacity: 1,
          }}
        />

        {images.length > 1 && (
          <>
            {/* Previous Button */}
            <button
              onClick={goToPrevious}
              style={{ ...styles.navButton, left: '8px' }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.7'}
            >
              <ChevronLeft style={styles.navIcon} />
            </button>

            {/* Next Button */}
            <button
              onClick={goToNext}
              style={{ ...styles.navButton, right: '8px', left: 'auto' }}
              onMouseEnter={(e) => e.target.style.opacity = '1'}
              onMouseLeave={(e) => e.target.style.opacity = '0.7'}
            >
              <ChevronRight style={styles.navIcon} />
            </button>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div style={styles.dotsContainer}>
          {images.map((_, index) => (
            <button
              key={index}
              onClick={(e) => goToSlide(index, e)}
              style={{
                ...styles.dot,
                backgroundColor:
                  index === currentImageIndex
                    ? 'rgb(244, 183, 48)'
                    : 'rgba(255, 255, 255, 0.5)',
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  sliderContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  imageWrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  },
  productImage: {
    width: '100%',
    height: '358px',
    objectFit: 'cover',
    display: 'block',
  },
  productListImage: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    opacity: '0.7',
    transition: 'opacity 0.3s ease',
    zIndex: 2,
  },
  navIcon: {
    width: '18px',
    height: '18px',
  },
  dotsContainer: {
    position: 'absolute',
    bottom: '10px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '6px',
    zIndex: 2,
  },
  dot: {
    width: '10px',
    height: '10px',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

export default ProductImageSlider;
